import React, { useEffect, useState } from "react";
import RemiseFilter from "../../../../Components/Remises/RemiseV2/RemiseFilter";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../../_App/Redux/hooks";
import { societeId } from "../../../../_App/Redux/Slices/Auth/authSlice";
import { datafilterType } from "../../../../_App/Types/Entites/ArticleFilter";
import PaginationLayout from "../../../../_Layouts/Pagination/PaginationLayout";
import { DesactiverRemiseApi, findListRemiseFiltresApi, ListRemiseFiltre } from "../../../../_App/Redux/Slices/remise/remiseSlice";
import Select from "react-select";
import { allOrganisationsApi, ListOrganisations } from "../../../../_App/Redux/Slices/organisations/organisationSlice";
import ListRemise from "../../../../Components/Remises/RemiseV2/ListRemise";
import { ToastSuccess } from "../../../../Shared/Toasts/ToastSuccess";
import { ToastWarning } from "../../../../Shared/Toasts/ToastWarning";

export default function ListRemiseV2Page() {
  const { t } = useTranslation();

  const listOrganisation = useAppSelector(ListOrganisations);
  const listRemiseFiltre =useAppSelector(ListRemiseFiltre)

  const societe = useAppSelector(societeId);
  const dispatch = useAppDispatch();
  const [Filtre, setFiltre] = useState<datafilterType>();
  const [selections, setSelections] = useState<any>({});
  const [selectedOrg, setselectedOrg] = useState([]);

  
  const handleOrgChange = (newValue: any) => {
    setselectedOrg(newValue);
  };

  useEffect(() => {
    if (societe) {
      setFiltre((prev: any) => ({
        ...prev,
        societe: societe,
        NLigne: 100,
      }));
      dispatch(allOrganisationsApi(societe));
    }
  }, [societe]);

  
  const optionsOrganisation: any = listOrganisation.map((item: any) => ({
    value: item._id.toString(),
    label: item.nom,
  }));

  const desactiverRemise =async(id:string,etat:boolean)=>{
    const data = {idremise:id,etat}
    const resp = await dispatch(DesactiverRemiseApi(data))
     if (resp.payload.success) {
          ToastSuccess("l'etat de remise change ");
        } else {
          ToastWarning(resp.payload.message);
        }

  }
  const searchfiltre = () => {
    const carateristiqueOptions: any[] = [];

    for (const key in selections) {
      if (Array.isArray(selections[key])) {
        selections[key].forEach((obj: any) => {
          carateristiqueOptions.push(obj.value);
        });
      }
    }
    const copie = { ...Filtre };
    copie.index = 1;
    copie.type = "fils";
    copie.carateristique = carateristiqueOptions;
    copie.societe = societe;

    setFiltre(copie);
    const copiefiltre = {
      ...copie,
      Organisation: selectedOrg.map((org: any) => org.value),
    };
    dispatch(findListRemiseFiltresApi(copiefiltre));
  };

  return (
    <div>
      <div className="  bg-white" style={{ padding: "10px" }}>
        <div className="row ">
          <div className="col-4">
            <div className="form-group">
              <label htmlFor="carte">
                {" "}
                <span style={{ color: "red" }}></span>
                {t("Organisation")}
              </label>

              <Select
                isMulti
                options={optionsOrganisation}
                value={selectedOrg}
                onChange={handleOrgChange}
                placeholder="Sélectionner familles"
              />
            </div>
          </div>
        </div>
      </div>
      <RemiseFilter
        t={t}
        societeid={societe}
        setFiltre={setFiltre}
        Filtre={Filtre}
        searchfiltre={searchfiltre}
        selections={selections}
        setSelections={setSelections}
      />
            <ListRemise  desactiverRemise={desactiverRemise} t={t} listRemiseFiltre={listRemiseFiltre}/>

    </div>
  );
}
